import React, { useEffect, useState } from 'react';
import styles from './SettingsContentMobile.module.scss';
import { useUserContext } from '../../../../context/UserContext';
import ProfileOptionsList from '../../../../../engage/components/ProfileOptionsList/ProfileOptionsList';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import useLanguage from '../../../../hooks/useLanguage';

import Modal from '../../../../components/Modal';
import ChangeLanguage from '../../../../components/Sidebar/ChangeLanguage';

const SettingsContentMobile = () => {
  const history = useHistory();
  const { user, reloadUser } = useUserContext();

  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView, setIsMobileView] = useState(mediaMatch.matches);

  useEffect(() => {
    const initUser = async () => {
      const vormatsUser = await reloadUser();
      setLoaded(true);
      console.log('User after init', vormatsUser);
    };
    if (!user) initUser();
  }, [reloadUser, user]);

  const { t } = useTranslation();

  const { isLanguageMenu, setIsLanguageMenu, language, setLanguage, languages } = useLanguage();

  const toggleChat = () => {
    if (!$crisp.is('chat:opened')) {
      $crisp.push(['do', 'chat:show']);
      $crisp.push(['do', 'chat:open']);
    } else {
      $crisp.push(['do', 'chat:hide']);
      $crisp.push(['do', 'chat:close']);
    }
  };

  /**
   * Menu options available only for mobile version - to show first Account & preferences menu
   */
  const menuOptions = {
    settings: [
      {
        name: t('sidebar.profile.account_settings'),
        action: () => history.push('/eg/settings', { showProfileSettings: true }),
      },
      isMobileView
        ? null
        : {
            name: t('company.settings.title'),
            action: () => history.push('/eg/company-settings'),
          },
    ],
    help: [
      // {name: 'Help center', path: '/eg/help'},
      { name: t('sidebar.profile.chat'), action: toggleChat },
    ],
    language: [{ name: t('sidebar.profile.set_language'), action: () => setIsLanguageMenu(true), flagImage: language.flagPath }],
    instruments: [{ name: t('sidebar.profile.download_mobile_app'), path: '/eg/download' }],
    signOut: [{ name: t('sidebar.profile.sign_out'), path: '/logout' }],
  };

  /**
   * Action for menu items, if another doesn't spicify in option object by 'action' field
   *
   */
  const handleSelectOptions = value => {
    if (value.startsWith('https', 0)) {
      window.open(value, '_blank');
    } else {
      history.push(value);
    }
  };

  return (
    <div>
      <div className={styles.menuWrapper}>
        <h2 className={styles.menuHeader}>{t('account.settings.mobile_title')}</h2>
        <div className={styles.userInfo}>
          <p className={styles.userName}>{user.userFullName}</p>
          <p>{user.userEmail}</p>
        </div>
        <ProfileOptionsList options={menuOptions} onSelect={handleSelectOptions} />
      </div>
      <Modal open={isLanguageMenu} onClose={() => setIsLanguageMenu(false)} focusTrapped={false}>
        <div className={styles.languageModal}>
          <ChangeLanguage
            languages={languages}
            language={language}
            setLanguage={setLanguage}
            isLanguageMenu={isLanguageMenu}
            setIsLanguageMenu={setIsLanguageMenu}
            isMobileView={isMobileView}
          />
        </div>
      </Modal>
    </div>
  );
};

export default SettingsContentMobile;
